export function formatTitle(title: string, searchText: string) {
	const cleanTitle = title.trim();
	const cleanSearchText = searchText.trim().replace(/[^a-z0-9 -]/gi, "");
	let highlightedTitle = cleanTitle;

	const matchIndices = [...cleanTitle.matchAll(new RegExp(cleanSearchText, "gi"))]
		.map((a) => a.index)
		.sort((a, b) => Number(b) - Number(a));

	for (let i = 0; i < matchIndices.length; i++) {
		const index = matchIndices[i] ?? 0;
		const startIndex = index;
		const endIndex = startIndex + cleanSearchText.length;

		const beforeInsert = highlightedTitle.slice(0, startIndex);
		const insert = highlightedTitle.slice(startIndex, endIndex);
		const afterInsert = highlightedTitle.slice(endIndex);

		highlightedTitle = `${beforeInsert}<span class='font-bold'>${insert}</span>${afterInsert}`;
	}

	return highlightedTitle;
}
